(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annoucment-contdown"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.announcement-slider').on('init', function () {
    const bar = document.querySelector('.announcement-bar-slider');
    bar.classList.remove('slider-hidden');
    bar.classList.add('slider-ready');

    startCountdown(); // start countdown after visible
  }).slick({
    infinite: true,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  function startCountdown() {
    document.querySelectorAll('.countdown-timer').forEach(function (timer) {
      const endTime = new Date(timer.getAttribute('data-end')).getTime();

      function update() {
        const now = new Date().getTime();
        const diff = endTime - now;

        if (diff <= 0) {
          timer.innerHTML = '<div class="countdown-ended">Sale ended</div>';
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        timer.querySelector('.days').textContent = String(days).padStart(2, '0');
        timer.querySelector('.hours').textContent = String(hours).padStart(2, '0');
        timer.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
        timer.querySelector('.seconds').textContent = String(seconds).padStart(2, '0');
      }

      update();
      setInterval(update, 1000);
    });
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card-slider"] && !window.DesignMode) return;
  try {
    
  $('.card_image_slider').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 979,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        dots: true,
         slidesToShow: 1
      }
    }
  ]
});



  } catch(e) { console.error(e); }
})();
})();
